import { useEffect, useRef, useState } from 'react';
import { Routes, Route, useLocation, useSearchParams } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import {
  ENTRA_AUTHORIZE_BASE_URL,
  AUTH_ADMIN_CLIENT_IDS,
  AUTH_ADMIN_REDIRECT_URIS,
  ENTRA_TENANT_ID,
} from '../envVars';

// Components
//import { Home } from '../pages/home/Home';
import { isUserAuthenticated, isLoggedInAuthenticated, getAmwayLoginUrl, LoggerService } from '../ui/utils';
// Auth & Profile
import { Header, Login /* ForgotPassword */ } from '../ui/app-components';
import { AdminHome } from '../pages/admin/Admin';
import { AuthCallback } from '../pages/admin/AuthCallback';
import { Landing } from '../pages/Landing';
//import { DynamicObjectInterface } from '../sdk/type';
import { Footer } from '../ui/app-components/Footer';
import { PrivacyMain } from '../pages/privacy/Privacy';
import { TermsMain } from '../pages/terms/Terms';
import { AdminToast, ToastProvider } from '../ui/components';
import { Certificate } from '../pages/profile/Certificate';
import { getContent } from '../sdk/services/contentService';

// MSAL configuration for Microsoft Entra ID
const msalConfig = {
  auth: {
    clientId: AUTH_ADMIN_CLIENT_IDS,
    authority: `https://${ENTRA_AUTHORIZE_BASE_URL}/${ENTRA_TENANT_ID}`,
    redirectUri: AUTH_ADMIN_REDIRECT_URIS,
    postLogoutRedirectUri: window.location.origin + '/admin',
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

// Add MSAL event callback for debugging authentication issues
msalInstance.addEventCallback((event: any) => {
  if (event.error) {
    console.log('[MSAL Error] JSON:', JSON.stringify(event.error, null, 2));
  }
});

const AppRoutes = () => {
  //const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const sourceParam = searchParams.get('source');
  const teamParam = searchParams.get('t');
  const idParam = searchParams.get('id');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLogInAuthenticated, setIsLogInAuthenticated] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [showHeader, setShowHeader] = useState(true);
  const isProd = useRef(window.location.hostname === 'portal.amwaynow.sg').current;

  useEffect(() => {
    if (isLogin === false) {
      setIsAuthenticated(isUserAuthenticated());
      setIsLogInAuthenticated(isLoggedInAuthenticated());
    } else {
      setIsAuthenticated(isLogin);
      setIsLogInAuthenticated(isLogin);
    }
  }, [isLogin, showHeader]);

  useEffect(() => {
    const url = window.location.pathname;
    if (
      url.startsWith('/privacy-security') ||
      url.startsWith('/terms-and-conditions') ||
      url.startsWith('/certificate') ||
      url.startsWith('/promotions') ||
      idParam
    ) {
      setShowHeader(false);
    } else if (url.startsWith('/admin')) {
      //always show header for admin:
      setIsAuthenticated(true);
      setIsLogInAuthenticated(true);
      setShowHeader(true);
    } else {
      setShowHeader(true);
    }
  }, [location, isAuthenticated, isLogInAuthenticated, isLogin]);

  useEffect(() => {
    const shouldFetchConfig = location.pathname === '/login/redirect';

    if (!shouldFetchConfig) return;

    const fetchAndRedirect = async () => {
      try {
        const config = await getContent('user_login', 'userLogin', false);

        if (config) {
          const url = getAmwayLoginUrl({ source: sourceParam, teamParam: teamParam, id: idParam, postLoginUrl: idParam ? '/promotions' : null });
          window.location.replace(url);
        }
      } catch (error) {
        LoggerService.log('fetchPortalConfig: Failed to retrieve content data. Using default content.');

        const url = getAmwayLoginUrl({ source: sourceParam, teamParam: teamParam, id: idParam, postLoginUrl: idParam ? '/promotions' : null });
        window.location.replace(url);
      }
    };

    fetchAndRedirect();
  }, [location.pathname]);

  // useEffect(() => {
  //     setIsAuthenticated(isUserAuthenticated());
  //     setIsLogInAuthenticated(isLoggedInAuthenticated());

  // }, []);
  // Check if running on localhost
  // const isLocalhost = window.location.hostname === 'localhost';

  return (
    <MsalProvider instance={msalInstance}>
      {isAuthenticated && isLogInAuthenticated && showHeader && <Header />}
      <Routes>
        {!isProd && (
          <>
            <Route path="/auth/login" element={<Login />} />
            <Route path="/auth/login?source=email" element={<Login />} />
          </>
        )}
        <Route path="/admin/authorize" element={<AuthCallback />} />
        <Route path="/admin/*" element={<AdminHome />} />
        {/* <Route
          path="/admin/*"
          element={
            isLocalhost ? (
              <AdminHome />
            ) : isAuthenticated ? (
              <AdminHome />
            ) : (
              <PreLoginPage accessType={FrameworkRole.ADMIN} />
            )
          }
        /> */}
        <Route
          path="/*"
          element={
            <ToastProvider>
              <AdminToast timeout={100000} topPosition="100px">
                <Landing setIsLogin={setIsLogin} />
              </AdminToast>
            </ToastProvider>
          }
        />
        {/* <Route path="*" element={<Home />} /> */}
        <Route path="/privacy-security" element={<PrivacyMain />} />
        <Route path="/terms-and-conditions" element={<TermsMain />} />
        <Route path="/certificate" element={<Certificate />} />
      </Routes>
      <Footer campaignId={idParam}/>
    </MsalProvider>
  );
};

export default AppRoutes;
